import axios from "../services/axiosInstance"; // Ensure correct import

const API_URL = `https://api.cityzoom.in/api/users`; 

// ✅ Fetch All Users
export const fetchUsers = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("🔥 Error fetching users:", error.response?.data || error.message);
    return { users: [], error: error.response?.data?.error || "Failed to fetch users" };
  }
};

// ✅ Create New User
export const createUser = async (userData) => {
  try {
    console.log("📢 Creating user with data:", userData);
    const response = await axios.post(`${API_URL}/register`, userData); // Ensure correct endpoint
    console.log("✅ User created successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("🔥 Error creating user:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Failed to create user");
  }
};

// ✅ Update User
export const updateUser = async (id, updateData) => {
  try {
    console.log(`🔄 Updating user ${id} with data:`, updateData);
    const response = await axios.put(`${API_URL}/${id}`, updateData);
    console.log("✅ User updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("🔥 Error updating user:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Failed to update user");
  }
};

// ✅ Delete User
export const deleteUser = async (id) => {
  try {
    console.log(`🗑️ Deleting user ${id}...`);
    await axios.delete(`${API_URL}/${id}`);
    console.log("✅ User deleted successfully");
    return true;
  } catch (error) {
    console.error("🔥 Error deleting user:", error.response?.data || error.message);
    return false;
  }
};
